import React, { Component, Fragment } from 'react'
import DonutLoader from '../sub-components/DonutLoader';
import './loadpage.css';
import logo from '../images/logo.svg';
import Timer from 'react-compound-timer'
import Clock from 'react-live-clock';

import loadsStore from '../../stores/loads-store';
import LoadHeader from './LoadHeaderUpdated';
import NavHamburger from '../sub-components/NavHamburger/NavContainer';

class LoadAllContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            completedLoads: [],
            activeLoads: [],
            loads: [],
        }
        this.loadEvents = [
            { name: loadsStore.getEventPrefix('getExistingLoads'), func: this.handleExistingLoads },
            { name: loadsStore.getEventPrefix('getExistingLoadsLoadcall'), func: this.handleExistingLoadsLoadcall },
            { name: loadsStore.getEventPrefix('createLoad'), func: this.handleNewLoad },
            { name: loadsStore.getEventPrefix('updateAllLoads'), func: this.handleUpdateLoads },
            { name: loadsStore.getEventPrefix('updateLoad2'), func: this.handleUpdateLoad2 },
            { name: loadsStore.getEventPrefix('updateLoadHeader'), func: this.handleUpdateLoad },
        ]
    }
    componentWillMount = () => {
        this.loadEvents.forEach((evnt) => loadsStore.on(evnt.name, evnt.func))
    }
    componentDidMount() {
        loadsStore.loadAllExistingLoads();
    }
    componentWillUnmount = () => {
        this.loadEvents.forEach((evnt) => loadsStore.removeListener(evnt.name, evnt.func));
    }
    handleNewLoad = (loads) => {
        let activeLoads = this.filterLoads(loads);
        this.setState({ activeLoads })
    }
    handleUpdateLoad2 = (loads) => {
        let activeLoads = this.filterLoads(loads);
        this.setState({ activeLoads })
    }

    handleUpdateLoads = (loads) => {
        let activeLoads = this.filterLoads(loads);
        this.setState({ activeLoads })
    }
    handleUpdateLoad = (load) => {
        console.log('in handle Update Load in LoadCall Container');
        let { activeLoads } = this.state;
        let newLoads = [];
        let idx = activeLoads.findIndex(l => l.loadNum === load.loadNum);
        if (idx === -1) {
            newLoads = [...activeLoads, load];
        }
        else {
            newLoads = [...activeLoads];
            newLoads[idx] = load;
        }
        newLoads = this.filterLoads(newLoads);
        console.log(newLoads);
        this.setState({ activeLoads: newLoads })

    }
    filterLoads = (loads) => {
        return loads.sort((a,b) => a.loadNum - b.loadNum).filter(load => {
            // if ispaused===false, time is running
            return (!load.isPaused && !load.inAir)
        })
    }
    handleExistingLoads = (loads) => {
        let activeLoads = this.filterLoads(loads.activeLoads);
        this.setState({
            activeLoads,
            isLoading: false,
        });
    }

    handleExistingLoadsLoadcall = (loads) => {
        let activeLoads = this.filterLoads(loads);
        this.setState({
            activeLoads,
            isLoading: false,
        });
    }
    returnLoads = () => {
        let { isLoading, activeLoads } = this.state;
        if (!isLoading && activeLoads.length > 0) {
            return activeLoads.map(load => {
                return (
                    // <div className="col-12 col-md-10 col-lg-8 m-1">
                    <div className="load-call-header m-2" >
                        <LoadHeader loadObj={load} />
                    </div>)
            })
        }
        else if (!isLoading) {
            return <h1>No Loads Available</h1>
        }
    }


    render() {
        let { isLoading } = this.state;

        return (
            isLoading ?
                <DonutLoader isLoading={isLoading} addClass={'sample1'} />
                :
                <>
                    <div className="load-all-page">
                        <NavHamburger />
                        <div className="returnloads-container">
                            {/* <div className="row pl-3 w-100 justify-content-center"> */}
                            {this.returnLoads()}
                        </div>
                        <div className="live-clock">
                            <h1>
                                <Clock format="h:mm:ss A" interval={1000} ticking={true} />
                            </h1>
                        </div>
                        <img src={logo} alt="logo" className={`dizio-logo`} />
                    </div>
                </>

        )
    }
}
export default LoadAllContainer
